import { render, staticRenderFns } from "./ItemRenew.vue?vue&type=template&id=550434c2&scoped=true"
import script from "./ItemRenew.vue?vue&type=script&lang=ts"
export * from "./ItemRenew.vue?vue&type=script&lang=ts"
import style0 from "./ItemRenew.vue?vue&type=style&index=0&id=550434c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550434c2",
  null
  
)

export default component.exports